module.exports = __webpack_public_path__ + "static/media/rectangle-mobile-logged-in.03883e3a.svg";